import React from 'react';

const Card = ({ children, className = '', title = '' }) => {
  return (
    <div
      className={`rounded-xl3 border border-glass-border bg-glass px-6 py-7 backdrop-blur-lg shadow-glass ${className}`}
    >
      {title && (
        <h3 className="mb-4 text-xs uppercase tracking-[0.26em] text-muted">
          {title}
        </h3>
      )}
      {children}
    </div>
  );
};

export default Card;
